module.exports = __webpack_public_path__ + "img/InitUnityFrameworkInstall.5b81e79f.gif";